// DEPRECATED (Phase 7): The old breakdown/reporting flows are deprecated.
// All new issue reports must use the unified Ticketing System
// (`/tickets/new` or `TicketCreateForm`). This route only redirects.
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({ assetId: z.string().uuid().optional() });

export const Route = createFileRoute("/_authenticated/report-breakdown")({
  validateSearch: (s) => searchSchema.parse(s),
  beforeLoad: ({ search }) => {
    // Legacy route — redirect to unified Create Ticket flow.
    if (search.assetId) {
      throw redirect({ to: "/assets/$assetId/report-issue", params: { assetId: search.assetId } });
    }
    throw redirect({ to: "/tickets/new" });
  },
  component: () => null,
});
